import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#20BEE8',
        secondary: '#BFADA5',
        accent: '#6B8699',
        info: '#5B5C79',
        error: '#DF3121',
        success: '#0B8900',
        dark: "#ffffff",
        light: "#f5f8f9",
        text: "#a8bdd2",
        "strong-text": "#ddeeff",
        "footer-bg": "#2c2b2b",
        "text-light": "#646984"
      }
    }
  }
});
